import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default props => {
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_BD_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => {
        const {prjId, sVer} = map.data
        const {bdName, pkid} = map.root.data

        const dppIds = [...map.selectedNodes]
            .filter(n => {
                const {bizNodeType, pkid} = n.data

                if (! (pkid && 'BDLOGIC' === bizNodeType)) {
                    return false
                }

                const _n = map.nodeProxy(n)
                return _n.isMounted()
            })
            .map(n => n.data.pkid)

        openWindow(
            '/Ai',

            {
                bizMap: {dpId: pkid, dppIds},
                prjId,
                scene: 'GENERATE_CATLOGIC',
                sVer,
                title: `程序模块: ${bdName}`,
            }
        )
    }

    return {
        label: '程序能力定制分类',
        onClick,
        ...props,
    }
}
